import { render } from "./MremRegistrationForm.vue?vue&type=template&id=0ede3c74&scoped=true"
import script from "./MremRegistrationForm.vue?vue&type=script&lang=js"
export * from "./MremRegistrationForm.vue?vue&type=script&lang=js"

import "./MremRegistrationForm.vue?vue&type=style&index=0&id=0ede3c74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ede3c74"]])

export default __exports__